<template>
  <div class="SignalCardTextDv">
    <div class="headingInfoHeadDv">
      <h3
        :class="{
          buy: addPostModelDv.position === 'buy',
          sell: addPostModelDv.position === 'sell',
          neutral: addPostModelDv.position === 'neutral',
        }"
        v-if="addPostModelDv.position === 'buy'"
      >
        <IconComponent class="priceIcon" icon="stock-pricing-up-icon.svg" />
        BULLISH <span class="caption-text">{{ addPostModelDv.title }}</span>
      </h3>
      <h3
        :class="{
          buy: addPostModelDv.position === 'buy',
          sell: addPostModelDv.position === 'sell',
          neutral: addPostModelDv.position === 'neutral',
        }"
        v-if="addPostModelDv.position === 'sell'"
      >
        <IconComponent class="priceIcon" icon="stock-pricing-up-icon.svg" />
        BEARISH <span class="caption-text">{{ addPostModelDv.title }}</span>
      </h3>
      <h3
        :class="{
          buy: addPostModelDv.position === 'buy',
          sell: addPostModelDv.position === 'sell',
          neutral: addPostModelDv.position === 'neutral',
        }"
        v-if="addPostModelDv.position === 'neutral'"
      >
        NEUTRAL <span class="caption-text">{{ addPostModelDv.title }}</span>
      </h3>
    </div>
    <p>{{ addPostModelDv.description }}</p>
  </div>
  <div
    class="signalCardsDv"
    :class="{ fromPopup: fromPopup }"
    v-if="addPostModelDv && addPostModelDv.title && stock"
  >
    <div class="signalHeader">
      <div class="firstDv">
        <StockImageTag
          :stockId="stock.stockId"
          :imgUrl="stock.logoUrl"
          :symbol="stock.symbol"
          :market="stock?.type"
        />
        <div class="textDv">
          <h2>{{ stock.symbol ?? "-" }}</h2>

          <el-tooltip
            class="box-item"
            effect="dark"
            :content="stock.name ?? '-'"
            placement="top-start"
          >
            <p>{{ stock.name ?? "-" }}</p>
          </el-tooltip>
        </div>
      </div>
      <div class="endDv">
        <div class="lastDv">
          <h2
            class="whiteDoler"
            ref="priceElement"
            v-html="
              $filters.systemNumberConvention(
                stock.price,
                true,
                false,
                widthCalculating
              )
            "
          ></h2>
          <div
            :class="{
              downward: stock.changesPercentage < 0,
            }"
            class="informationGridWatchlistViewDv"
          >
            <el-tooltip
              class="box-item"
              effect="dark"
              :content="'$' + stock.change"
              placement="top-start"
            >
              <div>
                <IconComponent
                  class="priceIcon"
                  icon="stock-pricing-up-icon.svg"
                />
                {{
                  Math.abs(
                    $filters.systemNumberConvention(
                      stock.changesPercentage,
                      false
                    )
                  )
                }}%
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="signalMiddle">
      <SparklineComponent
        v-if="showChart"
        :isPositive="stock?.changesPercentage >= 0"
        :data="stock?.fiveDayTrend?.[0].data"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted, ref, watch } from "vue";
import IconComponent from "@/components/IconComponent.vue";
import { useSocketStockData } from "@/composables/stock_data.composable";
import { SocketStock } from "@/helpers/models/stock/socket_stock.model";
import httpService from "@/services/http.service";
import storageService from "@/services/storage.service";
export default defineComponent({
  components: {
    IconComponent,
  },
  props: ["addPostModelDv", "fromPopup", "fromStock"],
  setup(props, context) {
    const { stockData: stock, updateStockInfoObject } = useSocketStockData(
      props.addPostModelDv.stock
    );

    watch(
      () => props.addPostModelDv.stock,
      async (newStockData) => {
        updateStockInfoObject(props.addPostModelDv.stock);
        console.log(props.addPostModelDv.stock, "props.addPostModelDv.stock");

        await nextTick(); // Ensure DOM updates immediately
      },
      { deep: true }
    );

    const showChart = ref(false);
    onMounted(async () => {
      updateStockInfoObject(props.addPostModelDv.stock);
      // console.log(props.addPostModelDv.stock, 'props.addPostModelDv.stock onMounted');

      if (priceElement.value) {
        const width = priceElement.value.offsetWidth;
        widthCalculating.value = width;
        props.addPostModelDv.stock.showTrendChart = true;
        props.addPostModelDv.stock.fiveDayTrend = [];
      }

      if (stock.value && stock.value._id) {
        const stockIds = [stock.value._id];

        const token = storageService.getToken();
        const user = storageService.getUser();
        if (!token || !user || !user._id) {
          const chartApiResponse = await httpService.getPublicStockChartData(
            stockIds
          );
          if (chartApiResponse.data) {
            const chartData = chartApiResponse.data; // Use the .data property
            if (chartData[stock.value._id]) {
              stock.value.fiveDayTrend = [{ data: chartData[stock.value._id] }];
              showChart.value = true;
            }
          }
        } else {
          const chartApiResponse = await httpService.getStockChartData(
            stockIds
          );
          if (chartApiResponse.data) {
            const chartData = chartApiResponse.data; // Use the .data property
            if (chartData[stock.value._id]) {
              stock.value.fiveDayTrend = [{ data: chartData[stock.value._id] }];
              showChart.value = true;
            }
          }
        }
      }
    });

    const priceElement = ref<HTMLElement | null>(null);
    const widthCalculating = ref();

    watch(priceElement, () => {
      if (priceElement.value) {
        const width = priceElement.value.offsetWidth;
        widthCalculating.value = width;
      }
    });

    watch(props.fromStock, () => {
      if (props.fromStock === true) {
        // stock.value = new SocketStock();
      }
    });

    return {
      priceElement,
      stock,
      widthCalculating,
      showChart,
    };
  },
});
</script>

<style lang="scss">
.SignalCardTextDv {
  margin-bottom: 10px;

  .headingInfoHeadDv {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    gap: 5px;

    h3 {
      text-transform: capitalize;
      font-size: var(--font-2md);
      line-height: 1;
      letter-spacing: 0px;
      padding: 0px;
      margin: 0px;
      color: var(--text-color);
      font-weight: 600;

      .caption-text {
        color: var(--text-color);
        font-weight: 400;
      }

      .priceIcon {
        color: var(--recommend-bullish);
        fill: var(--color-positive);
        width: 13px;
        flex: 0 0 13px;
        height: 13px;
        margin: 0px 0px 0px 0px;
      }

      &.buy {
        color: var(--recommend-bullish);

        .priceIcon {
          color: var(--recommend-bullish);
          fill: var(--recommend-bullish);
        }
      }

      &.sell {
        color: var(--recommend-bearish);

        .priceIcon {
          transform: rotate(180deg);
          color: var(--recommend-bearish);
          fill: var(--recommend-bearish);
        }
      }

      &.neutral {
        color: var(--recommend-hold);

        .priceIcon {
          color: var(--recommend-hold);
          fill: var(--recommend-hold);
        }
      }
    }

    h4 {
      font-size: var(--font-2md);
      line-height: 1;
      letter-spacing: 0px;
      padding: 0px;
      margin: 0px;
      color: var(--text-color);
      font-weight: 400;
    }
  }

  p {
    font-size: var(--font-2sm);
    line-height: 1.4;
    letter-spacing: 0px;
    padding: 0px;
    margin: 0px;
    color: var(--text-color);
    font-weight: 400;
  }
}
.SignalCardInfoDv .iconDvSignalPostCreate {
  position: absolute;
  z-index: 9;
  top: -5px;
  right: -5px;
  width: 18px;
  height: auto;
  cursor: pointer;
}

.signalCardsDv {
  background: var(--base-light);
  border: 1px solid transparent;
  border-radius: 10px;
  margin: 0px 0px 0px;
  padding: 15px 15px 0px 15px;
  box-sizing: border-box;
  border: 1px solid var(--base-new-border);

  .signalHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0;
    position: relative;
    cursor: pointer;

    &.fluidWrapper {
      width: 100%;
    }

    .iconDv {
      width: 16px;
      height: 18px;

      &.removeOnRightCenter {
        position: static;
        max-width: 18px;
        flex: 0 0 18px;
        height: 22px;
        margin-inline-start: 5px;
        order: 4;
      }
    }

    .firstDv {
      width: 50%;
      max-width: 50%;
      display: flex;
      align-items: center;
      gap: var(--tile-horizontal-gap);
      justify-content: flex-start;

      .textDv {
        overflow: hidden;

        h2 {
          @include stockSymbol();
          margin-top: 5px;
          font-size: var(--font-2md);
          color: var(--text-color);
        }

        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          letter-spacing: 0px;
          padding: 0px;
          font-size: var(--font-2sm);
          color: var(--color-new-light-gray8);
          margin: 0;
          font-weight: 400;
        }
      }
    }

    .endDv {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 50%;
      max-width: 50%;
      margin-inline-start: auto;

      .lastDv {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: column;

        h2 {
          @include stockPrice();
          line-height: normal;
          color: var(--text-color);
          font-size: var(--font-2md);
          font-weight: 600;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          text-align: right;
          width: 100%;
        }

        span {
          @include changePercent();
          line-height: normal;
          font-size: var(--font-2sm);
          width: 100%;
        }

        .whiteDoler {
          span {
            color: var(--text-color);
          }
        }

        .informationGridWatchlistViewDv {
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          color: var(--recommend-bullish);
          line-height: normal;
          font-size: var(--font-2sm);
          width: 100%;

          &.downward {
            color: var(--color-negative);

            h2 {
              color: var(--color-negative);

              span {
                color: var(--color-negative);
              }
            }

            .priceIcon {
              fill: var(--color-negative);
              transform: rotate(180deg);
              top: -0.5px;
            }
          }

          h2 {
            font-weight: 500;
            color: var(--recommend-bullish);
            line-height: normal;
            font-size: var(--font-2sm);
          }

          .priceIcon {
            color: var(--recommend-bullish);
            fill: var(--color-positive);
            width: 10px;
            flex: 0 0 10px;
            height: 10px;
            margin: 0px 1px 0px 0px;
          }
        }
      }

      .iconmiunusDv {
        width: 18px;
        height: 18px;
        margin-inline-start: 15px;
      }
    }

    &:last-child {
      margin: 0px;
    }

    &.selected {
      border-color: var(--orange);
    }
  }

  .signalMiddle {
    margin: 20px 0px 0px;
  }
}

@media (min-width: 1280px) and (max-width: 1891px) {
  .SignalCardTextDv {
    .headingInfoHeadDv {
      h3 {
        .priceIcon {
          height: 8px;
          width: 8px;
        }

        font-size: var(--font-1xs);
      }

      h4 {
        font-size: var(--font-1xs);
      }
    }

    p {
      font-size: var(--font-1xs);
    }
  }

  .signalCardsDv {
    padding: 8px 8px 0;

    .signalHeader {
      .endDv {
        .lastDv {
          h2 {
            font-size: var(--font-xs);
          }

          .informationGridWatchlistViewDv {
            .priceIcon {
              width: 6px;
              flex: 0 0 6px;
              height: 6px;
            }

            h2 {
              font-size: var(--font-2xs);
            }

            font-size: var(--font-2xs);
          }
        }
      }

      .firstDv {
        .textDv {
          h2 {
            font-size: var(--font-xs);
          }

          p {
            font-size: var(--font-2xs);
          }
        }
      }
    }
  }
}

// .CreatePostSignalInfo {
//   .signalCardsDv {
//     background: var(--base-light);
//   }
// }
// .fromPopup {
//   background: var(--base-light);
// }
</style>
